import { FileWithPath } from "@mantine/dropzone"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import type { Document } from "@tfg/db"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"

export const useUploadDocumentsMutation = (
  options?: UseMutationOptions<Document[], AxiosError, FileWithPath[]>
) => {
  return useMutation(async (files: FileWithPath[]) => {
    return Promise.all(
      files.map(async (file) => {
        const formData = new FormData()
        formData.set("file", file)

        const response = await httpClient.post("documents/upload", formData)
        return response.data
      })
    )
  }, options)
}
